const WIDTH_CLASSES = {
  '40%': 'te-card--w40',
  '50%': 'te-card--w50',
  '60%': 'te-card--w60',
  '70%': 'te-card--w70',
  '85%': 'te-card--w85',
  '100%': 'te-card--w100',
  '720px': 'te-card--w720',
  1280: 'te-card--w1280'
};

/**
 * Maps the legacy `width` prop of the layout containers to a CSS modifier from
 * Card.css, so the width stays in the stylesheet instead of an inline style.
 * @param {string|number} [width] - Value passed by the call site, e.g. '70%' or 1280
 * @returns {string} Modifier class name, or '' to keep the card's default width
 */
const getCardWidthClass = (width) => WIDTH_CLASSES[String(width)] ?? '';

export default getCardWidthClass;
